function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallReturni = function SvgCallReturni(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M5.07 9.764H16.2a4.112 4.112 0 0 1 .03 8.22H6.88c-.45 0-.8.359-.8.8s.35.8.8.8h9.15l.06.002.16-.002h.08a1 1 0 0 0 .12-.009 5.72 5.72 0 0 0 5.35-5.7c0-3.029-2.36-5.51-5.34-5.701a1 1 0 0 0-.13-.01h-.11l-.13-.001-.05.001H4.98l2.45-2.375a.795.795 0 0 0 .02-1.131.8.8 0 0 0-1.13-.018L2.44 8.39a.85.85 0 0 0-.24.587.8.8 0 0 0 .26.58l3.88 3.519a.8.8 0 0 0 1.13-.054.795.795 0 0 0-.06-1.13z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallReturni);
export default ForwardRef;